import React, { useContext, useState } from "react";
import { FormControl } from "react-bootstrap";
import { Controller } from "react-hook-form";

import { showErrorInput } from "../../../../utils/helperFunctions";

import CardItemContext from "./../../../../context/CardItem/CardItemContext";
import { onlyNumber } from "../../../../utils/Tools";

//کامپوننت مورد نظر برای فرم استپ دوم سبد خرید
const FormStepTwo = ({ formController }) => {
  const { userData, setUserData, submitOrder } = useContext(CardItemContext);

  return (
    <form
      id="shopping-list-form"
      className="d-flex flex-column col-10 align-self-center m-auto"
      onSubmit={formController.handleSubmit(submitOrder)}
    >
      <div className="d-flex flex-column justify-content-between flex-lg-row align-items-lg-center pd-x-8 my-1">
        <span className="col-auto font-12-600 mr-l-12 mr-b-8">
          نام و نام خانوادگی:{" "}
        </span>
        <div className="col-lg-8">
          <FormControl
            {...formController.register("fullname")}
            placeholder="مثال: نام نام خانوادگی"
            className="mx-2 col font-12-400 shadow-none he-40"
            type="text"
            // value={userData.fullname}
            // onChange={(e) => {
            //   setUserData((prev) => {
            //     return { ...prev, fullname: e.target.value };
            //   });
            // }}
          />

          {showErrorInput(formController.formState.errors, "fullname")}
        </div>
      </div>
      <div className="d-flex flex-column justify-content-between flex-lg-row align-items-lg-center pd-x-8 my-1">
        <span className="col-auto font-12-600 mr-l-12 mr-b-8">آدرس: </span>
        <div className="col-lg-8">
          <FormControl
            {...formController.register("address")}
            placeholder="مثال: خیابان شهدا و ..."
            className="mx-2 col font-12-400 shadow-none he-40"
            type="text"
            // value={userData.address}
            // onChange={(e) => {
            //   setUserData((prev) => {
            //     return { ...prev, address: e.target.value };
            //   });
            // }}
          />
          {showErrorInput(formController.formState.errors, "address")}
        </div>
      </div>
      <div className="d-flex flex-column justify-content-between flex-lg-row align-items-lg-center pd-x-8 my-1">
        <span className="col-auto font-12-600 mr-l-12 mr-b-8">موبایل: </span>
        <div className="col-lg-8">
          <Controller
            control={formController.control}
            name="mobile"
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <FormControl
                style={{ direction: "rtl" }}
                placeholder="مثال: 09123456789 "
                className="mx-2 col font-12-400 shadow-none he-40"
                value={value}
                onChange={({ target }) => {
                  if (target.value.length > 11) return;
                  onChange(onlyNumber(target.value));
                }}
              />
            )}
          />

          {showErrorInput(formController.formState.errors, "mobile")}
        </div>
      </div>
      <div className="d-flex flex-column justify-content-between flex-lg-row align-items-lg-center pd-x-8 my-1">
        <span className="col-auto font-12-600 mr-l-12 mr-b-8">تلفن : </span>
        <div className="col-lg-8">
          <Controller
            control={formController.control}
            name="tell2"
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <FormControl
                style={{ direction: "rtl" }}
                placeholder="مثال: 01712345678"
                className="mx-2 col font-12-400 shadow-none he-40"
                value={value}
                onChange={({ target }) => {
                  if (target.value.length > 11) return;
                  onChange(onlyNumber(target.value));
                }}
              />
            )}
          />

          {showErrorInput(formController.formState.errors, "tell2")}
        </div>
      </div>
      <div className="d-flex flex-column justify-content-between flex-lg-row align-items-lg-center pd-x-8 my-1">
        <span className="col-auto font-12-600 mr-l-12 mr-b-8">کدپستی: </span>
        <div className="col-lg-8">
          <Controller
            control={formController.control}
            name="zipCode"
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <FormControl
                style={{ direction: "rtl" }}
                placeholder="مثال: 4911111111 "
                className="mx-2 col font-12-400 shadow-none he-40"
                value={value}
                onChange={({ target }) => {
                  if (target.value.length > 10) return;
                  onChange(onlyNumber(target.value));
                }}
              />
            )}
          />

          {showErrorInput(formController.formState.errors, "zipCode")}
        </div>
      </div>
    </form>
  );
};
export default FormStepTwo;
